import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ConfirmProvider } from "@/context/ConfirmContext";
import { LocationProvider } from "@/context/LocationContext";
import { OfflineOverlay } from "@/components/OfflineOverlay";
import { PushPrompt } from "@/components/PushPrompt";
import { SelectSheet } from "@/components/SelectSheet";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ListingDetail from "@/pages/ListingDetail";
import SearchPage from "@/pages/SearchPage";
import PublikoPage from "@/pages/PublikoPage";
import EditListingPage from "@/pages/EditListingPage";
import PuneHub from "@/pages/PuneHub";
import KerkoPunePage from "@/pages/KerkoPunePage";
import JepPunePage from "@/pages/JepPunePage";
import KrijoProfilPage from "@/pages/KrijoProfilPage";
import SeekerDetail from "@/pages/SeekerDetail";
import { VisitTracker } from "@/components/VisitTracker";
import { CookieBanner } from "@/components/CookieBanner";
import { RouteSeo } from "@/lib/seo";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import MessagesPage from "@/pages/MessagesPage";
import ProfilePage from "@/pages/ProfilePage";
import PointsPage from "@/pages/PointsPage";
import BuyCreditsPage from "@/pages/BuyCreditsPage";
import BuyHomeAdPage from "@/pages/BuyHomeAdPage";
import CreditPrompt from "@/components/CreditPrompt";
import QrPage from "@/pages/QrPage";
import ScanPage from "@/pages/ScanPage";
import SuggestBusinessPage from "@/pages/SuggestBusinessPage";
import EditProfilePage from "@/pages/EditProfilePage";
import SecurityPage from "@/pages/SecurityPage";
import SettingsPage from "@/pages/SettingsPage";
import { ProximityWatcher } from "@/components/ProximityWatcher";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SavedPage from "@/pages/SavedPage";
import NotificationsPage from "@/pages/NotificationsPage";
import CommunityPage from "@/pages/CommunityPage";
import CommunityThread from "@/pages/CommunityThread";
import ReklamePage from "@/pages/ReklamePage";
import MapPage from "@/pages/MapPage";
import AdminPage from "@/pages/AdminPage";
import AdminUserDetail from "@/pages/AdminUserDetail";
import FriendsPage from "@/pages/FriendsPage";
import FriendRequestsPage from "@/pages/FriendRequestsPage";
import PublicProfilePage from "@/pages/PublicProfilePage";
import TvPage from "@/pages/TvPage";
import TvLinkPage from "@/pages/TvLinkPage";

const NotOnTv = ({ children }) => (useLocation().pathname.startsWith("/tv") ? null : children);
import { useLocation as useRouterLocation } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";

function RouteBoundary({ children }) {
  const loc = useRouterLocation();
  return <ErrorBoundary resetKey={loc.pathname}>{children}</ErrorBoundary>;
}

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <BrowserRouter>
          <ConfirmProvider>
            <OfflineOverlay />
            <NotOnTv>
            <CreditPrompt />
            <VisitTracker />
            <RouteSeo />
            <CookieBanner />
            <PushPrompt />
            <ProximityWatcher />
            </NotOnTv>
            <SelectSheet />
            <RouteBoundary>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/kategoria/:key" element={<CategoryPage />} />
                <Route path="/shpallje/:id" element={<ListingDetail />} />
                <Route path="/politika-cookies" element={<CookiePolicyPage />} />
                <Route path="/kerko" element={<SearchPage />} />
                <Route path="/publiko" element={<PublikoPage />} />
                <Route path="/ndrysho/:id" element={<EditListingPage />} />
                <Route path="/pune-hub" element={<PuneHub />} />
                <Route path="/kerko-pune" element={<KerkoPunePage />} />
                <Route path="/jep-pune" element={<JepPunePage />} />
                <Route path="/krijo-profil-pune" element={<KrijoProfilPage />} />
                <Route path="/punekerkues/:id" element={<SeekerDetail />} />
                <Route path="/mesazhe" element={<MessagesPage />} />
                <Route path="/mesazhe/:userId" element={<MessagesPage />} />
                <Route path="/profil" element={<ProfilePage />} />
                <Route path="/piket" element={<PointsPage />} />
                <Route path="/gjejkredit" element={<PointsPage />} />
                <Route path="/gjejkredit/bli" element={<BuyCreditsPage />} />
                <Route path="/gjejkredit/reklame" element={<BuyHomeAdPage />} />
                <Route path="/qr" element={<QrPage />} />
                <Route path="/skano" element={<ScanPage />} />
                <Route path="/q" element={<ScanPage />} />
                <Route path="/trego-biznes" element={<SuggestBusinessPage />} />
                <Route path="/profil/ndrysho" element={<EditProfilePage />} />
                <Route path="/siguria" element={<SecurityPage />} />
                <Route path="/cilesimet" element={<SettingsPage />} />
                <Route path="/reset" element={<ResetPasswordPage />} />
                <Route path="/te-ruajtura" element={<SavedPage />} />
                <Route path="/njoftimet" element={<NotificationsPage />} />
                <Route path="/komunitete" element={<CommunityPage />} />
                <Route path="/komunitete/:id" element={<CommunityThread />} />
                <Route path="/reklame" element={<ReklamePage />} />
                <Route path="/harta" element={<MapPage />} />
                <Route path="/lidh-tv/:pc" element={<TvLinkPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/user/:id" element={<AdminUserDetail />} />
                <Route path="/shoqeria" element={<FriendsPage />} />
                <Route path="/kerkesat" element={<FriendRequestsPage />} />
                <Route path="/perdorues/:id" element={<PublicProfilePage />} />
              </Route>
              <Route path="/tv" element={<TvPage />} />
              <Route path="/tv/:code" element={<TvPage />} />
            </Routes>
            </RouteBoundary>
          </ConfirmProvider>
        </BrowserRouter>
      </LocationProvider>
    </AuthProvider>
  );
}

export default App;
